var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '@xyo-network/sdk-xyo-js';
import global from '../../global';
class Fbq {
    constructor(pixelId) {
        this.pixelId = pixelId;
        this.fbq = function () {
            // eslint-disable-next-line prefer-rest-params,prefer-spread
            this.fbq.callMethod ? this.fbq.callMethod.apply(this.fbq, arguments) : this.fbq.queue.push(arguments);
        };
        this.fbq.push = this.fbq;
        this.fbq.loaded = true;
        this.fbq.version = '2.0';
        this.fbq.queue = [];
        //we have to set these to globals because that is where the facebook script looks for them
        global.fbq = this.fbq;
        global._fbq = this.fbq;
        this.fbq('init', pixelId);
        this.fbq('track', 'PageView');
    }
    static init(pixelId) {
        if (!this.instance) {
            this.instance = new Fbq(pixelId);
        }
        return this.instance;
    }
    track(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.fbq('track', event, Object.assign({}, data));
            yield delay(0);
        });
    }
    trackCustom(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.fbq('trackCustom', event, Object.assign({}, data));
            yield delay(0);
        });
    }
}
export default Fbq;
//# sourceMappingURL=Fbq.js.map